export default "__VITE_ASSET__B1Kf5393__"